import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow container mx-auto p-4">
        <Outlet />
      </main>

      <footer className="bg-gray-100 p-4">
        <div className="container mx-auto text-center text-gray-500">
          &copy; {new Date().getFullYear()} GenFLOW React Frontend
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
